import type { Palette } from '@mui/material'

/**
 * These colors are the same on every mode
 */

/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const staticPalette: Palette['static'] = {
  dark: '#030303',
  goGreen: '#006443',
  light: '#FFFEFE',
}
